/**
 * 浏览器环境相关
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */
export const UA = window.navigator.userAgent.toLowerCase()

export const isAndroid = /android/i.test(UA)

export const isIOS = /iphone os/i.test(UA)

export const isFusion = /fusionkit/i.test(UA)

const iosRE = /iphone os ([\d_]+)/i
const androidRE = /android[ /]([\d\.]+)/i

export const iosVersion = (() => {
  let version = ''
  if (isIOS) {
    let match = UA.match(iosRE)
    version = match[1]
  }
  return version.replace(/_/g, '.')
})()

export const androidVersion = (() => {
  let version = ''
  if (isAndroid) {
    let match = UA.match(androidRE)
    version = match[1]
  }
  return version
})()



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/util/env.js